import Text from '@helvetia/components/Text'
import { styled } from '@helvetia/components/theme'
import * as React from 'react'

interface Props {
  leftText: string
  rightText: string
  bold?: boolean
}

const PriceBoxItem: React.SFC<Props> = ({ leftText, rightText, bold }) => {
  const fontType = bold ? 'sBold' : 's'
  return (
    <PriceItemWrapper>
      <Text as="span" color="tertiary" size={fontType}>
        {leftText}
      </Text>
      <Text as="span" color="tertiary" size={fontType}>
        {rightText}
      </Text>
    </PriceItemWrapper>
  )
}

const PriceItemWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

export default PriceBoxItem
